import React, { useState, useEffect } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import {
  Typography,
  Box,
  Grid,
  Paper,
  TextField,
  InputAdornment,
  Badge,
  Button,
  FormControl,
  CircularProgress,
  Select,
  MenuItem,
  Fade,
} from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { db, functions } from '../firebase';
import Layout from '../components/Layout';
import PictureDialog from '../components/PictureDialog';
import DialogBill from '../components/dialogs/bill';
import AccountCircle from '@material-ui/icons/AccountCircle';
import CakeIcon from '@material-ui/icons/Cake';
import HelpIcon from '@material-ui/icons/Help';
import SaveIcon from '@material-ui/icons/Save';
import HomeIcon from '@material-ui/icons/Home';
import PeopleIcon from '@material-ui/icons/People';
import moment from 'moment';
import 'moment/locale/th';
moment().locale('th');

const Bill = () => {
  let { id } = useParams();
  let history = useHistory();
  const [bill, setBill] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    let mounted = true;
    const getBill = async () => {
      db.collection('billings')
        .doc(id)
        .get()
        .then((docRef) => {
          if (docRef.exists) {
            setBill({ ...docRef.data(), id: docRef.id });
          }
        })
        .catch(function (error) {
          console.log('Error getting documents: ', error);
        });
    };
    if (mounted) {
      getBill();
    }

    return () => (mounted = false);
  }, [id, history]);

  const handleStatus = (event) => {
    setBill({ ...bill, status: event.target.value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    db.collection('billings')
      .doc(bill.id)
      .update({ status: bill.status })
      .then(() => {
        setLoading(false);
        setSuccess(true);
        setTimeout(() => {
          setSuccess(false);
        }, 3000);
        if (bill.status === 'ชำระเงินแล้ว') {
          const confirmBillingCallable = functions.httpsCallable(
            'confirmBilling'
          );
          confirmBillingCallable(bill);
        }
      });
  };

  return (
    <Layout>
      {bill && (
        <Grid container spacing={2} style={{ justifyContent: 'center' }}>
          <Grid item sm={6} md={4}>
            <Box component={Paper} p={3}>
              <Box textAlign="center">
                <Badge
                  color="secondary"
                  badgeContent={
                    (bill?.promotion === 'promotion1' && 3) ||
                    (bill?.promotion === 'promotion2' && 5)
                  }
                >
                  <PictureDialog
                    fullname={bill?.fullname}
                    picture={bill?.pictureUrl}
                  />
                </Badge>
                <Typography variant="h5" component="h3">
                  รายละเอียด
                </Typography>
              </Box>
              {bill?.fullname && (
                <TextField
                  label="ชื่อ-สกุล"
                  defaultValue={bill.fullname}
                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircle />
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                  style={{ marginBottom: 8 }}
                />
              )}
              {bill.birthday && (
                <TextField
                  label="วันเกิด"
                  defaultValue={bill.birthday}
                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment position="start">
                        <CakeIcon />
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                  style={{ marginBottom: 8 }}
                />
              )}
              <Box>
                <TextField
                  label="คำถามที่ 1"
                  defaultValue={bill.question.question1}
                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment position="start">
                        <HelpIcon />
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                  style={{ marginBottom: 8 }}
                />

                <TextField
                  label="คำถามที่ 2"
                  defaultValue={bill.question.question2}
                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment position="start">
                        <HelpIcon />
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                  style={{ marginBottom: 8 }}
                />

                <TextField
                  label="คำถามที่ 3"
                  defaultValue={bill.question.question3}
                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment position="start">
                        <HelpIcon />
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                  style={{ marginBottom: 8 }}
                />
                {bill.promotion === 'promotion2' && (
                  <>
                    <TextField
                      label="คำถามที่ 4"
                      defaultValue={bill.question.question4}
                      InputProps={{
                        readOnly: true,
                        startAdornment: (
                          <InputAdornment position="start">
                            <HelpIcon />
                          </InputAdornment>
                        ),
                      }}
                      fullWidth
                      style={{ marginBottom: 8 }}
                    />
                    <TextField
                      label="คำถามที่ 5"
                      defaultValue={bill.question.question5}
                      InputProps={{
                        readOnly: true,
                        startAdornment: (
                          <InputAdornment position="start">
                            <HelpIcon />
                          </InputAdornment>
                        ),
                      }}
                      fullWidth
                      style={{ marginBottom: 8 }}
                    />
                  </>
                )}
              </Box>
              {bill.pictures && bill.pictures.length > 0 && (
                <Box>
                  <Typography
                    variant="caption"
                    component="h6"
                    style={{ color: 'rgba(0, 0, 0, 0.54)' }}
                  >
                    บุคคลที่เกี่ยวข้อง
                  </Typography>
                  <Grid container spacing={2} alignItems="center">
                    {bill.pictures.map((other, key) => (
                      <Grid
                        item
                        xs={12}
                        xl={4}
                        key={`person-${key}`}
                        className="lg:w-1/3 w-full px-3"
                      >
                        <Box p={2} textAlign="center">
                          <PictureDialog
                            selectedValue="picture"
                            fullname={`person_${key + 1}`}
                            picture={other.image}
                          />
                          <TextField
                            label="บุคคลที่เกี่ยวข้อง"
                            defaultValue={other.title}
                            InputProps={{
                              readOnly: true,
                              startAdornment: (
                                <InputAdornment position="start">
                                  <PeopleIcon />
                                </InputAdornment>
                              ),
                            }}
                            fullWidth
                            style={{ marginBottom: 8 }}
                          />
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              )}
              <Box textAlign="center">
                <DialogBill
                  src={bill.billUrl}
                  picture={bill?.pictureUrl}
                  fullname={bill?.fullname}
                />
              </Box>
              <Box pt={5}>
                <FormControl fullWidth>
                  <Select value={bill?.status} onChange={handleStatus}>
                    <MenuItem value="รอการตรวจสอบ">รอการตรวจสอบ</MenuItem>
                    <MenuItem value="ชำระเงินแล้ว">ชำระเงินแล้ว</MenuItem>
                    <MenuItem value="มีคำตอบแล้ว">มีคำตอบแล้ว</MenuItem>
                    <MenuItem value="ส่งคำตอบแล้ว">ส่งคำตอบแล้ว</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              {success && (
                <Fade in={success} style={{ marginTop: 8, marginBottom: 8 }}>
                  <Alert severity="success">
                    <AlertTitle>ส่งข้อมูลสำเร็จ</AlertTitle>
                    นี่คือการแจ้งเตือนว่าส่งข้อมูลสำเร็จ —{' '}
                    <strong>ทำการอัพเดทสเตตัสเป็น {bill.status}!</strong>
                  </Alert>
                </Fade>
              )}
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                py={3}
              >
                {!loading ? (
                  <>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<SaveIcon />}
                      onClick={() => handleSubmit()}
                      style={{ marginRight: 8 }}
                    >
                      อัพเดทข้อมูล
                    </Button>
                    <Link to="/bills" style={{ textDecoration: 'none' }}>
                      <Button variant="contained" startIcon={<HomeIcon />}>
                        กลับสู่หน้าหลัก
                      </Button>
                    </Link>
                  </>
                ) : (
                  <CircularProgress />
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
      )}
    </Layout>
  );
};

export default Bill;
